<template>
  <div class="page_panel">
    <div class="line_slider" v-if="routeLineArr && routeLineArr.length > 0">
      <el-slider v-model="roadLineWeight" :min="1" :max="10" vertical height="200px" @change="roadLineWeightChange"></el-slider>
    </div>
    <!--
    <div class="layer-tool">
      <div class="item" :class="{ active: !isLayers }" @click="layersChange(false)"><i class="iconfont icon-ditu"></i>地图</div>
      <div class="item" :class="{ active: isLayers }" @click="layersChange(true)"><i class="iconfont icon-yingxiang"></i>卫星</div>
    </div>
    <div class="zoom-tool">
      <div class="item" @click="zoomChange(true)">
        <i class="el-icon-plus"></i>
      </div>
      <div class="item" @click="zoomChange(false)">
        <i class="el-icon-minus"></i>
      </div>
    </div>
    -->
    <div v-if="false" class="search-panel">
      <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="100px">
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item prop="drcId">
              <el-input clearable disabled v-model.trim="form.drcId" placeholder="终端序列号" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="false">
            <el-form-item prop="wholeVehicleNumber">
              <el-input clearable v-model.trim="form.wholeVehicleNumber" placeholder="底盘/机架号" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="3.5">
            <el-form-item prop="email">
              <el-date-picker
                v-model="dateRange[0]"
                disabled
                :clearable="false"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                align="right"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3.5">
            <el-form-item prop="email">
              <el-date-picker disabled v-model="dateRange[1]" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" align="right"> </el-date-picker>
            </el-form-item>
          </el-col>
          <!--
          <el-col :span="4">
            <el-button type="primary" icon="iconfont icon-guiji" @click="vehicleTrackHandler">历史轨迹</el-button>
          </el-col>
          -->
        </el-row>
      </el-form>
    </div>
    <!--
    <div class="info-panel" @click="visibleIsShow = true">
      <i class="iconfont icon-nongjixinxi"></i>
      <span class="text">
        农机
        <br />信息
      </span>
      <div class="info-detail" v-if="visibleIsShow" @click.stop.prevent="() => {}">
        <div class="info-hide">
          <span>车辆信息</span>
          <i class="iconfont icon-shouqi" @click.self.stop="visibleIsShow = false">X</i>
        </div>
        <div class="info-content">
          <div class="info-header">
            <el-row :gutter="0">
              <el-col :span="12">
                <span class="name">{{ vehicleInfo.brandName | defaultDataFilter }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">机主姓名：</span>
                <span class="value">{{ vehicleInfo.brandName | defaultDataFilter }}</span>
              </el-col>
              <el-col :span="12">
                <span class="model">{{ vehicleInfo.vehicleTypeName | defaultDataFilter }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">机手电话：</span>
                <span class="value">{{ vehicleInfo.phone | phoneFormat | defaultDataFilter }}</span>
              </el-col>
            </el-row>
          </div>
          <div class="info-container">
            <el-row :gutter="0">
              <el-col :span="12">
                <div class="text-panel">
                  <div class="label">车辆型号：</div>
                  <div class="value">{{ vehicleInfo.vehicleModuleName | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="text-panel">
                  <div class="label">车牌号：</div>
                  <div class="value">{{ vehicleInfo.vehicleCard | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">底盘/机架号：</div>
                  <div class="value">{{ vehicleInfo.wholeVehicleNumber | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">主机制造商：</div>
                  <div class="value">{{ vehicleInfo.makerName | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">归属地址：</div>
                  <div class="value">{{ vehicleInfo.address | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">车辆位置：</div>
                  <div class="value">{{ vehicleInfo.lastAddress | defaultDataFilter }}</div>
                </div>
              </el-col>

              <template v-if="vehicleInfo.terminalType && vehicleInfo.terminalType.includes('作业终端')">
                <el-col :span="24"><div class="terminal-tip">作业终端信息</div></el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">IMEI号：</div>
                    <div class="value">{{ vehicleInfo.drcId | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">设备号：</div>
                    <div class="value">{{ vehicleInfo.hardWareId | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="text-panel">
                    <div class="label">终端供应商：</div>
                    <div class="value">{{ vehicleInfo.drcMakerName | defaultDataFilter }}</div>
                  </div>
                </el-col>
              </template>

              <template v-if="vehicleInfo.terminalType && vehicleInfo.terminalType.includes('定位终端')">
                <el-col :span="24"><div class="terminal-tip">定位终端</div></el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">IMEI号：</div>
                    <div class="value">{{ getTerminalCode(vehicleInfo.terminalArr, 1, "terminalId") | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">设备号：</div>
                    <div class="value">{{ getTerminalCode(vehicleInfo.terminalArr, 1, "hardWareId") | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">终端供应商：</div>
                    <div class="value">--</div>
                  </div>
                </el-col>
              </template>

              <template v-if="vehicleInfo.terminalType && vehicleInfo.terminalType.includes('自驾仪')">
                <el-col :span="24"><div class="terminal-tip">自驾仪</div></el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">IMEI号：</div>
                    <div class="value">{{ getTerminalCode(vehicleInfo.terminalArr, 2, "terminalId") | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">设备号：</div>
                    <div class="value">{{ getTerminalCode(vehicleInfo.terminalArr, 2, "hardWareId") | defaultDataFilter }}</div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="text-panel">
                    <div class="label">终端供应商：</div>
                    <div class="value">--</div>
                  </div>
                </el-col>
              </template>

              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">发动机编号：</div>
                  <div class="value">{{ vehicleInfo.engineId | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">车辆归属：</div>
                  <div class="value">{{ vehicleInfo.owner | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">归属组织机构代码：</div>
                  <div class="value">{{ vehicleInfo.idCard | idCardFormat | defaultDataFilter }}</div>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">归属类型：</div>
                  <div class="value">{{ vehicleInfo.ownerType | defaultDataFilter }}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="text-panel">
                  <div class="label">联系方式：</div>
                  <div class="value">{{ vehicleInfo.phone | defaultDataFilter }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    -->
    <el-image style="display: none" ref="preViewFile" :preview-src-list="[preViewFile]" :src="preViewFile" alt />
    <div id="vehicleTrackMap"></div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { vehicleMapShadow } from "../api/vehicleTrack";
import { getVehicleSelectByModelList } from "../api/index";
/* eslint-disable */
var _CarTrack;
var number = 1;
// 创建自定义图标构造函数
var definedOverlay;
// 构建路线箭头
var roadDefinedOverlay;
// 构建路线农机
var nongjiDefinedOverlay;
var activeGps = [];
// 侧面工具
var polygonTool;
// 多边形集合
var polygons = [];
var centerMarkers = [];
var centerLabels = [];
var colors = ["#5473e8", "#ff9f24", "#fd5454", "#23bcca", "#38d180", "#8298e8", "#0C91F7", "#ffb657", "#fc8686", "#62d196"];
export default {
  name: "CarPath",
  filters: {
    defaultDataFilter(v) {
      return !v && v != 0 ? "--" : v;
    },
    phoneFormat(phone) {
      return phone && phone.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
    },
  },
  props: {
    /**
     * 是否组件形式展示
     * 默认： false
     */
    isComponent: {
      type: Boolean,
      default: false,
    },
    /**
     * 组件形式传入终端序列号
     * 默认： ''
     */
    comDrcId: {
      default: "",
    },
    /**
     * 组件形式传入车辆id
     * 默认： ''
     */
    comVehicleId: {
      default: "",
    },
    isSatellite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 所有轨迹路线记录，用于轨迹宽度条恒
      routeLineArr: [],
      // 轨迹路线宽度
      roadLineWeight: Cookies.get("vehicleRealTimeRoadLineWeight") ? Number(Cookies.get("vehicleRealTimeRoadLineWeight")) : 3,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      triggerType: true,
      // 测亩记录保存
      areaArray: [],
      loading: false,
      vehicleId: undefined,
      // 是否显示倍速条
      isSlider: false,
      // 是否播放
      player: false,
      // 是否显示农机数据层
      visibleIsShow: false,
      // 日期范围
      dateRange: [],
      // 表单校验
      rules: {},
      // 表单参数
      form: {
        sex: undefined,
        drcId: undefined,
        wholeVehicleNumber: undefined,
        engineId: undefined,
        vehicleBrand: undefined,
        vehicleCategory: undefined,
        vehicleModel: undefined,
        site: undefined,
      },
      countriesOverlay: null,
      // 是否卫星图层
      isLayers: false,
      // 地图
      myMap: null,
      // 地图配置
      options: {
        zoom: 10,
      },
      // 是否测量面积
      area: false,
      // 播放倍速
      speed: 0.1,
      showCar: false,
      // 是否显示车辆信息
      hasData: false,
      // 轨迹记录
      gpsData: [],
      // 车辆信息
      vehicleInfo: {},
      // 计时器获取轨迹进度
      trigger: null,
      // 轨迹播放进度
      percentage: 0,
      // 是否显示轨迹操作
      showOperation: false,
      // 绘制区域
      countries: [],
      // 解决图层绘制区域标记
      zoomFlag: true,
      trigger: undefined,
      // 预览图片
      preViewFile: null,
    };
  },
  watch: {
    isSatellite: {
      handler(v) {
        let self = this;
        self.layersChange(v);
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isComponent) {
      this.form.drcId = this.comDrcId;
      this.vehicleId = this.comVehicleId;
    } else {
      this.form.drcId = this.$route.query.drcId ? this.$route.query.drcId : undefined;
      this.vehicleId = this.$route.query.vehicleId ? this.$route.query.vehicleId : undefined;
    }
    this.dateRange = [this.parseTime(new Date().getTime() - 3600 * 1000), this.parseTime(new Date())];
    window.vmm = this;
    this.initMap();
    this.getVehicleECUdata();
    setInterval(() => {
      this.$set(this.dateRange, 1, this.parseTime(new Date()));
    }, 1000);
  },
  beforeDestroy() {
    // 清除获取轨迹进度
    if (this.trigger) clearInterval(this.trigger);
    // 组件销毁时需销毁车辆，否则会一直占用线程
    if (_CarTrack != null) {
      _CarTrack.clear();
    }
  },
  // destroyed() {
  //   this.destroyMap();
  // },
  methods: {
    // 获取终端号
    getTerminalCode(terminalArr, type, name) {
      if (terminalArr && terminalArr.length > 0) {
        let result = terminalArr.find((item) => {
          return item.terminalType == type;
        });
        return result ? result[name] : "";
      }
    },
    /** 添加计时器获取 */
    setTimer() {
      if (this.trigger) clearInterval(this.trigger);
      this.trigger = setInterval(() => {
        if (this.form.drcId) {
          number = 1;
          this.triggerType = false;
          this.getVehiclePath();
        }
      }, 2000);
    },
    /** 显示图片 */
    showImage(img) {
      this.preViewFile = img;
      this.$refs.preViewFile.showViewer = true;
    },
    // 历史轨迹查询处理
    vehicleTrackHandler() {
      if (this.isComponent) {
        this.$emit("goHistoryTrack");
      } else {
        this.$router.push({
          path: "/vehicleManagement/vehicleTrack/index",
          query: { drcId: this.form.drcId, vehicleId: this.vehicleId },
        });
      }
    },
    // 车辆轨迹宽度变更
    roadLineWeightChange() {
      this.routeLineArr.forEach((el) => {
        el.setWeight(this.roadLineWeight);
      });
      Cookies.set("vehicleRealTimeRoadLineWeight", this.roadLineWeight);
    },
    // 地图放大缩小
    zoomChange(type) {
      if (type) this.myMap.zoomIn();
      else this.myMap.zoomOut();
    },
    // 图层切换
    layersChange(type) {
      this.isLayers = type;
      if (!this.myMap) return;
      if (type) {
        this.myMap.setMapType(TMAP_HYBRID_MAP);
      } else {
        this.myMap.setMapType(TMAP_NORMAL_MAP);
      }
    },
    initCar() {
      if (_CarTrack != null) _CarTrack.clear();
      _CarTrack = new T.CarTrack(this.myMap, {
        interval: 5,
        speed: this.speed,
        dynamicLine: false,
        carstyle: {
          display: false,
          iconUrl: require("../../../assets/images/map_icon/icon_nongji.png"),
          width: 35,
          height: 22,
        },
        polylinestyle: {
          display: false,
          color: "#00EE00",
          width: "2",
          opacity: 0.8,
        },
        Datas: activeGps.map(function (obj, i) {
          var lnlat = new T.LngLat(obj.lng, obj.lat);
          return lnlat;
        }),
      });
    },
    initMap() {
      let self = this;
      // 清除获取轨迹进度
      if (this.trigger) clearInterval(this.trigger);
      return new Promise((resolve, reject) => {
        const that = this;
        that.myMap = new T.Map("vehicleTrackMap");
        that.myMap.centerAndZoom(new T.LngLat(116.40969, 39.89945), that.options.zoom);
        // 使用百度API获取当前位置并定位
        var lc = new T.LocalCity();
        lc.location(function (e) {
          that.myMap.centerAndZoom(e.lnglat, that.options.zoom);
        });
        // var ctrl = new T.Control.MapType();
        // that.myMap.addControl(ctrl);
        that.myMap.setMapType(self.isSatellite ? TMAP_HYBRID_MAP : TMAP_NORMAL_MAP);
        nongjiDefinedOverlay = T.Overlay.extend({
          initialize: function (lnglat, angle) {
            this.lnglat = lnglat;
            this.angle = angle;
          },
          onAdd: function (map) {
            this.map = map;
            var that = this;
            var div = (this._div = document.createElement("div"));
            div.style.position = "absolute";
            div.style.zIndex = "200";
            div.style.transformOrigin = "20% 30%";
            div.style.transform = `rotate(${that.angle - 100}deg)`;
            div.style.boxSizing = "border-box";
            var img = (this._span = document.createElement("img"));
            img.src = `${require("../../../assets/images/map_icon/icon_nongji.png")}`;
            img.style.width = "35px";
            // img.style.opacity = '0.5';
            div.appendChild(img);
            map.getPanes().overlayPane.appendChild(this._div);
            this.update(this.lnglat);
          },
          onRemove: function () {
            var parent = this._div.parentNode;
            if (parent) {
              parent.removeChild(this._div);
              this.map = null;
              this.div = null;
            }
          },
          setLnglat: function (lnglat) {
            this.lnglat = lnglat;
            this.update();
          },
          getLnglat: function () {
            return this.lnglat;
          },
          setPos: function (pos) {
            this.lnglat = this.map.layerPointToLngLat(pos);
            this.update();
          },
          /**
           * 更新位置
           */
          update: function () {
            var pos = this.map.lngLatToLayerPoint(this.lnglat);
            this._div.style.top = pos.y - 9 + "px";
            this._div.style.left = pos.x - 3 + "px";
          },
        });
        roadDefinedOverlay = T.Overlay.extend({
          initialize: function (lnglat, angle) {
            this.lnglat = lnglat;
            this.angle = angle;
          },
          onAdd: function (map) {
            this.map = map;
            var that = this;
            var div = (this._div = document.createElement("div"));
            div.style.position = "absolute";
            div.style.zIndex = "200";
            div.style.transform = `rotate(${that.angle}deg)`;
            div.style.boxSizing = "border-box";
            var img = (this._span = document.createElement("img"));
            img.src = `${require("../../../assets/images/map_icon/road.png")}`;
            img.style.width = "6px";
            // img.style.opacity = '0.5';
            div.appendChild(img);
            map.getPanes().overlayPane.appendChild(this._div);
            this.update(this.lnglat);
          },
          onRemove: function () {
            var parent = this._div.parentNode;
            if (parent) {
              parent.removeChild(this._div);
              this.map = null;
              this.div = null;
            }
          },
          setLnglat: function (lnglat) {
            this.lnglat = lnglat;
            this.update();
          },
          getLnglat: function () {
            return this.lnglat;
          },
          setPos: function (pos) {
            this.lnglat = this.map.layerPointToLngLat(pos);
            this.update();
          },
          /**
           * 更新位置
           */
          update: function () {
            var pos = this.map.lngLatToLayerPoint(this.lnglat);
            this._div.style.top = pos.y - 9 + "px";
            this._div.style.left = pos.x - 3 + "px";
          },
        });
        definedOverlay = T.Overlay.extend({
          initialize: function (lnglat, text, gpsData, params, options) {
            this.lnglat = lnglat;
            this.setOptions(options);
            this._gpsData = gpsData.map(function (obj, i) {
              var lnlat = new T.LngLat(obj.longitude, obj.latitude);
              return lnlat;
            });
            this._text = text;
            this._dateParams = params;
            this.label = new T.Label({
              text: `<b>${params.sTime}--${params.eTime}<b>`,
              position: this.lnglat,
              offset: new T.Point(3, -30),
            });
            if (number <= 10) {
              this._number = number;
            } else {
              number = 1;
            }
            switch (number) {
              case 1:
                this._color = "#5473e8";
                break;
              case 2:
                this._color = "#ff9f24";
                break;
              case 3:
                this._color = "#fd5454";
                break;
              case 4:
                this._color = "#23bcca";
                break;
              case 5:
                this._color = "#38d180";
                break;
              case 6:
                this._color = "#8298e8";
                break;
              case 7:
                this._color = "#4bbfc9";
                break;
              case 8:
                this._color = "#ffb657";
                break;
              case 9:
                this._color = "#fc8686";
                break;
              case 10:
                this._color = "#62d196";
                break;
              default:
                break;
            }
            // this._number = number;
            this._number = 1;
            number += 1;
          },
          onAdd: function (map) {
            this.map = map;
            var div = (this._div = document.createElement("div"));
            div.style.position = "absolute";
            div.style.zIndex = "300";
            var that = this;
            div.style.height = "46px";
            div.style.boxSizing = "border-box";
            div.style.padding = "5px 10px";
            div.style.width = "40px";
            div.style.background = `url(${require("../../../assets/images/map_icon/" + "icon_coordinates" + that._number + ".png")}) no-repeat`;
            // 创建线对象
            var route_line = new T.Polyline(that._gpsData, {
              color: colors[that._number - 1],
              weight: vmm.roadLineWeight,
              opacity: 1,
            });
            // 保存所有轨迹路线，用于改变路线宽度
            vmm.routeLineArr.push(route_line);
            // 将线加载到地图
            vmm.myMap.addOverLay(route_line);
            div.style.backgroundSize = "100% 100%";
            div.style.color = this._color;
            div.style.MozUserSelect = "none";
            div.style.fontSize = "14px";
            div.style.lineHeight = "30px";
            div.style.textAlign = "center";
            var span = (this._span = document.createElement("span"));
            div.appendChild(span);
            div.onmouseover = function () {
              vmm.myMap.addOverLay(that.label);
              this.style.zIndex = "999";
            };
            div.onmouseout = function () {
              vmm.myMap.removeOverLay(that.label);
              this.style.zIndex = "300";
            };
            span.appendChild(document.createTextNode(this._text));
            map.getPanes().overlayPane.appendChild(this._div);
            this.update(this.lnglat);
          },

          onRemove: function () {
            var parent = this._div.parentNode;
            if (parent) {
              parent.removeChild(this._div);
              this.map = null;
              this.div = null;
            }
          },

          setLnglat: function (lnglat) {
            this.lnglat = lnglat;
            this.update();
          },
          getLnglat: function () {
            return this.lnglat;
          },
          setPos: function (pos) {
            this.lnglat = this.map.layerPointToLngLat(pos);
            this.update();
          },
          /**
           * 更新位置
           */
          update: function () {
            var pos = this.map.lngLatToLayerPoint(this.lnglat);
            this._div.style.top = pos.y - 36 + "px";
            this._div.style.left = pos.x - 11 + "px";
          },
        });
        resolve("mapInit");
        // this.initCar();
      });
    },
    mapDrawInit(sel, transform) {
      var upd = sel.selectAll("path.geojson").data(this.countries);
      upd
        .enter()
        .append("path")
        .attr("class", "geojson")
        .attr("stroke", "black")
        .attr("fill", function (d, i) {
          return d3.hsl(Math.random() * 360, 0.9, 0.15);
        })
        .attr("fill-opacity", "0.15");
    },
    mapRedraw(sel, transform) {
      sel.selectAll("path.geojson").each(function (d, i) {
        d3.select(this).attr("d", transform.pathFromGeojson);
      });
    },
    mapDrawInit1(sel, transform) {
      var upd = sel.selectAll("path.geojson1").data(this.countries);
      upd
        .enter()
        .append("path")
        .attr("class", "geojson1")
        .attr("stroke", "black")
        .attr("fill", function (d, i) {
          return d3.hsl(Math.random() * 360, 0.9, 0.5);
        })
        .attr("fill-opacity", "0.5");
    },
    mapRedraw1(sel, transform) {
      sel.selectAll("path.geojson1").each(function (d, i) {
        d3.select(this).attr("d", transform.pathFromGeojson);
      });
    },
    // 获取中心点
    getCenterPoint(tempAreaBoundary) {
      const latArr = [];
      const lngArr = [];
      tempAreaBoundary.forEach((e) => {
        latArr.push(e.lat);
        lngArr.push(e.lng);
      });
      latArr.sort();
      lngArr.sort();

      return new T.LngLat((lngArr[0] + lngArr[lngArr.length - 1]) / 2, (latArr[0] + latArr[latArr.length - 1]) / 2);
    },
    calcAngle(start, end) {
      var p_start = this.myMap.lngLatToContainerPoint(start),
        p_end = this.myMap.lngLatToContainerPoint(end);
      var diff_x = p_end.x - p_start.x,
        diff_y = p_end.y - p_start.y;
      let angle = (360 * Math.atan2(diff_y, diff_x)) / (2 * Math.PI) + 90;
      return angle;
    },
    drawRoad() {
      let that = this;
      that.myMap.clearOverLays();
      if (_CarTrack != null) _CarTrack.clear();
      if (this.gpsData.length) {
        // 将所有点存入数组，为了设置获取最佳视野
        let allPoints = [];
        for (let index = 0; index < this.gpsData.length; index++) {
          const line = this.gpsData[index];
          let line_gps = line.list || [];
          // let line_gps = that.douglasPeucker(line.list, 1) ? that.douglasPeucker(line.list, 1) : [];
          var lnglats = [];
          let viewPoints = [];
          for (let i = 0; i < line_gps.length; i++) {
            if (line_gps[i].photoUrl) {
              console.log("addinfo");
              //创建图片对象
              var infoWin = new T.InfoWindow();
              var sContent = `<div style='margin:0px;width:100%;height:100%;padding:10px;'><img onclick="vmm.showImage('http://img-drc.chiaic.com/${line_gps[i].photoUrl}')" style='margin:0px;width:100%;height:100%' src='http://img-drc.chiaic.com/${line_gps[i].photoUrl}'></img><br/><div style='color:#fff;text-indent: 2em;font-size: 14px;line-height:30px'>拍摄时间：${line_gps[i].createTime}</div><div style='color:#fff;text-indent: 1em;font-size: 14px;line-height:30px'>拍摄点坐标：${line_gps[i].longitude}, ${line_gps[i].latitude}</div></div>`;
              infoWin.setContent(sContent);
              var icon = new T.Icon({
                iconUrl: `${require("../../../assets/images/map_icon/dian.png")}`,
                iconSize: new T.Point(8, 8),
                iconAnchor: new T.Point(0, 0),
              });
              //向地图上添加自定义标注
              var marker = new T.Marker(new T.LngLat(line_gps[i].longitude, line_gps[i].latitude), { icon: icon });
              that.myMap.addOverLay(marker);
              addClickHandler(sContent, marker);
            }
            allPoints.push(new T.LngLat(line_gps[i].longitude, line_gps[i].latitude));
            lnglats.push(new T.LngLat(line_gps[i].longitude, line_gps[i].latitude));
            if (i % 2 === 0 && i < line_gps.length - 1) {
              var lnglat1 = new T.LngLat(line_gps[i].longitude, line_gps[i].latitude);
              var next = new T.LngLat(line_gps[i + 1].longitude, line_gps[i + 1].latitude);
              var roadSign = new roadDefinedOverlay(lnglat1, this.calcAngle(lnglat1, next));
              vmm.myMap.addOverLay(roadSign);
            }
            if (i == 0) {
              // 第一个点设为标注点
              var lnglat1 = new T.LngLat(line_gps[i].longitude, line_gps[i].latitude);

              var pdefinedOverlay = new definedOverlay(lnglat1, `起`, line_gps, { sTime: line.sTime, eTime: line.eTime }, {});
              vmm.myMap.addOverLay(pdefinedOverlay);
              let winContent = `<div  class='info_win'>${line.sTime}----${line.eTime}</div>`;
            }
            if (i == line_gps.length - 1 && index === this.gpsData.length - 1) {
              var lnglat1 = new T.LngLat(line_gps[i - 1].longitude, line_gps[i - 1].latitude);
              var next = new T.LngLat(line_gps[i].longitude, line_gps[i].latitude);
              var roadSign = new nongjiDefinedOverlay(next, this.calcAngle(lnglat1, next));
              vmm.myMap.addOverLay(roadSign);
              // 最后一个点设为车辆最终点
            }
          }
        }
        // 展示图片事件
        function addClickHandler(content, marker) {
          marker.addEventListener("click", function (e) {
            clearInterval(that.trigger);
            openInfo(content, e);
          });
        }
        // 创建窗口展示图片信息
        function openInfo(content, e) {
          var point = e.lnglat;
          marker = new T.Marker(point); // 创建标注
          var markerInfoWin = new T.InfoWindow(content, { offset: new T.Point(0, 0) }); // 创建信息窗口对象
          vmm.myMap.openInfoWindow(markerInfoWin, point); //开启信息窗口
          markerInfoWin.addEventListener("close", function (e) {
            vmm.setTimer();
          });
        }
        setTimeout(() => {
          if (this.triggerType === true) {
            that.myMap.setViewport(allPoints);
          }
        }, 100);
      }
      if (!that.zoomFlag) that.zoomFlag = true;
    },
    calculationDistance(point1, point2) {
      let lat1 = point1.latitude;
      let lat2 = point2.latitude;
      let lng1 = point1.longitude;
      let lng2 = point2.longitude;
      let radLat1 = (lat1 * Math.PI) / 180.0;
      let radLat2 = (lat2 * Math.PI) / 180.0;
      let a = radLat1 - radLat2;
      let b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      return s * 6370996.81;
    },
    distToSegment(start, end, center) {
      let a = Math.abs(this.calculationDistance(start, end));
      let b = Math.abs(this.calculationDistance(start, center));
      let c = Math.abs(this.calculationDistance(end, center));
      let p = (a + b + c) / 2.0;
      let s = Math.sqrt(Math.abs(p * (p - a) * (p - b) * (p - c)));
      return (s * 2.0) / a;
    },
    compressLine(coordinate, result, start, end, dMax) {
      var that = this;
      if (start < end) {
        let maxDist = 0;
        let currentIndex = 0;
        let startPoint = coordinate[start];
        let endPoint = coordinate[end];
        for (let i = start + 1; i < end; i++) {
          let currentDist = that.distToSegment(startPoint, endPoint, coordinate[i]);
          if (currentDist > maxDist) {
            maxDist = currentDist;
            currentIndex = i;
          }
        }
        if (maxDist >= dMax) {
          //将当前点加入到过滤数组中
          result.push(coordinate[currentIndex]);
          //将原来的线段以当前点为中心拆成两段，分别进行递归处理
          this.compressLine(coordinate, result, start, currentIndex, dMax);
          this.compressLine(coordinate, result, currentIndex, end, dMax);
        }
      }
      return result;
    },
    /**
     *
     *@param coordinate 原始轨迹Array<{latitude,longitude}>
     *@param dMax 允许最大距离误差
     *@return douglasResult 抽稀后的轨迹
     *
     */
    douglasPeucker(coordinate, dMax = 10) {
      var that = this;
      if (!coordinate || !(coordinate.length > 2)) {
        return null;
      }
      coordinate.forEach((item, index) => {
        item.id = index;
      });
      let result = that.compressLine(coordinate, [], 0, coordinate.length - 1, dMax);
      result.push(coordinate[0]);
      result.push(coordinate[coordinate.length - 1]);
      let resultLatLng = result.sort((a, b) => {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) return 1;
        return 0;
      });
      resultLatLng.forEach((item) => {
        item.id = undefined;
      });
      return resultLatLng;
    },
    getVehicleECUdata() {
      // 重置轨迹播放进度
      self.percentage = 0;
      // 清除获取轨迹进度
      if (self.trigger) clearInterval(self.trigger);
      // 重置播放按钮
      self.player = false;
      // 获取车辆信息
      if (!this.form.drcId) {
        // this.$notify
        this.$notify.error({
          title: "终端编号不能为空",
        });
        return;
      }
      this.getVehiclePath(true);
      getVehicleSelectByModelList(this.form).then((res) => {
        if (res.data && res.data.length > 0) {
          this.vehicleInfo = res.data[0];
          if (this.vehicleInfo && this.vehicleInfo.kind == 1) {
            this.vehicleInfo.terminalType = [];
            this.vehicleInfo.terminalArr = [];
            if (this.vehicleInfo.drcId) {
              this.vehicleInfo.terminalType.push("作业终端");
            }
            if (this.vehicleInfo.terminals && this.vehicleInfo.terminals.length > 0) {
              let temp = this.vehicleInfo.terminals.map((it) => {
                if (it.terminalType) {
                  if (it.terminalType == 1) {
                    this.vehicleInfo.terminalArr.push(it);
                    return "定位终端";
                  }
                  if (it.terminalType == 2) {
                    this.vehicleInfo.terminalArr.push(it);
                    return "自驾仪";
                  }
                }
              });
              this.vehicleInfo.terminalType = this.vehicleInfo.terminalType.concat(temp);
            }
          }
        } else {
          this.vehicleInfo = {};
        }
      });
      this.hasData = true;
    },
    async getVehiclePath(isRunTimer = false) {
      if (this.dateRange && this.dateRange.length > 0) {
        this.form.sTime = this.dateRange[0];
        this.form.eTime = this.dateRange[1];
      } else {
        this.form.sTime = undefined;
        this.form.eTime = undefined;
      }
      this.loading = true;
      vehicleMapShadow(this.form)
        .then((res) => {
          this.loading = false;
          res.data.forEach((element, i) => {
            for (let j = element.length - 1; j >= 0; j--) {
              if (element[j].latitude === 0 || element[j].longitude === 0 || element[j].latitude > 180 || element[j].longitude > 180) {
                console.log("经纬度坐标异常，删除点 index: " + i + "层" + j);
                console.log("经纬度坐标: " + element[j].latitude + " " + element[j].longitude);
                element.splice(j, 1);
              }
            }
          });
          this.gpsData = res.data;
          console.log("this.gpsData :>> ", this.gpsData);
          if (_CarTrack != null) _CarTrack.clear();
          if (this.gpsData && this.gpsData.length > 0 && this.gpsData[0].length > 0) {
            this.drawRoad();
          } else {
            this.myMap.centerAndZoom(new T.LngLat(113.6277785, 33.993273), 9);
            this.myMap.clearOverLays();
            if (!this.zoomFlag) this.zoomFlag = true;
          }
          // console.log('this.gpsData :>> ', this.gpsData);
          if (isRunTimer) this.setTimer();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// 天地图样式有些是行内样式，提高权重可用/deep/和!important
::v-deep.tdt-label {
  padding: 0 6px !important;
  line-height: 16px !important;
}
::v-deep.tdt-label1 {
  // 包含数字的红色框体
  height: 22px;
  padding: 2px 5px;
}
::v-deep.tdt-img2 {
  // 红色垃圾箱的样式
  background-position: -42px -1px;
}
.page_panel {
  width: 100%;
  height: calc(100vh);
  position: relative;
  padding-left: 0px;
  padding-right: 0px;
  // border-radius: 8px;
  overflow: hidden;
  #vehicleTrackMap {
    width: 100%;
    height: 100%;
    position: relative;
    .tdt-pane {
      div span {
        color: #030441;
      }
    }
  }
  .serchModel {
    position: absolute;
    z-index: 1000;
    top: 110px;
    left: 2%;
    background-color: rgba(0, 0, 0, 0);
    padding: 0 10px;
    border-radius: 4px;
  }
  .serch_items {
    margin-top: 10px;
    height: 50px;
    line-height: 50px;
  }
  .find_player {
    position: absolute;
    z-index: 1000;
    top: 110px;
    left: 2%;
  }

  .car_control {
    position: absolute;
    z-index: 1000;
    bottom: 50px;
    left: 1%;
    .el-button--medium {
      font-size: 40px !important;
    }
  }
  .charts_model {
    width: 100%;
    position: absolute;
    z-index: 1000;
    bottom: 20px;
    left: 10px;
  }
  .info_model {
    width: 300px;
    position: absolute;
    z-index: 1000;
    bottom: 30px;
    right: 2%;
    background-color: #122d4e;
    padding: 10px;
    opacity: 0.8;
    color: #ffffff;
    border: 2px solid #030441;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    th {
      width: 120px;
    }
  }
}
.zoom-tool {
  position: absolute;
  right: 24px;
  bottom: 60px;
  z-index: 999;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px #999999;
  border-radius: 4px;
  .item {
    width: 44px;
    height: 55px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5473e8;
    position: relative;
  }
  .item:nth-of-type(1) {
    &::after {
      position: absolute;
      bottom: 0;
      left: 4px;
      right: 4px;
      height: 1px;
      background-color: #e5e5e5;
      content: "";
    }
  }
}
.search-panel {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2014;
  right: 0;
  .el-button--default {
    background-color: #23bcca;
    color: #ffffff;
  }
}

::v-deep.info-panel {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px 0px #999999;
  border-radius: 4px;
  position: absolute;
  top: 76px;
  right: 24px;
  z-index: 999;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5473e8;
  .text {
    opacity: 1;
  }
  .info-detail {
    position: absolute;
    top: 0;
    right: 0;
    width: 460px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px #888888;
    border-radius: 4px;
    .info-hide {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 16px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      background-color: #f1f1f1;
    }
    .info-content {
      .info-header {
        padding: 15px 24px;
        border-bottom: 1px solid #e5e5e5;
        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #5473e8;
        }
        .label {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 28px;
        }
        .value {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5473e8;
          line-height: 28px;
        }
        .model {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 28px;
        }
      }
      .info-container {
        padding: 15px 24px;
        .text-panel {
          display: flex;
          margin-bottom: 10px;
          .label {
            display: inline-block;
            width: 130px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            text-align: right;
          }
          .value {
            flex: 1;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
        }
      }
      .info-footer {
        width: 100%;
        height: 60px;
        background-color: #f1f1f1;
        padding: 0px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .iconfont {
          font-size: 30px;
        }
        .progress {
          flex: 1;
          margin-left: 18px;
          margin-right: 18px;
        }
        .double-speed {
          width: 55px;
          height: 32px;
          border: 1px solid #5473e8;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5473e8;
          line-height: 32px;
          text-align: center;
          background-color: #fff;
          position: relative;
          .slider {
            position: absolute;
            bottom: 40px;
            width: 65px;
            height: 150px;
            background: #ffffff;
            box-shadow: 0px 0px 7px 0px #dee5ff;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .el-slider__runway {
              .el-slider__button {
                background-color: #5473e8;
              }
              .el-slider__stop {
                display: none;
              }
              .el-slider__marks .el-slider__marks-text {
                font-size: 12px;
                width: 30px;
              }
            }
          }
        }
      }
    }
  }
}
// 调整轨迹宽度slider样式
.line_slider {
  height: 50px;
  position: absolute;
  top: calc(50% - 100px);
  z-index: 2000;
  left: 40px;
}
.terminal-tip {
  margin-bottom: 16px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  border-left-width: 3px;
  border-left-style: outset;
  border-color: #5473e8;
  padding-left: 5px;
}
</style>
